export function postRequest(url, data) {

    let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
    };
    data = data || {};
    return fetch(url, {
        headers,
        credentials:'include',
        method: "POST",
        body: JSON.stringify(data)
    }).then(function(res){
        if(res.status === 401){

        }
        return res.json()
    }).catch(e=>console.log(e))
}
export function patchRequest(url, data) {
    let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
    };
    data = data || {};
    return fetch(url, {
        headers,
        credentials:'include',
        method: "PATCH",
        body: JSON.stringify(data)
    }).then(function(res){
        if(res.status === 401){

        }
        return res.json()
    }).catch(e=>console.log(e))
}

export function getRequest(url) {
    let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
    };
    return fetch(url, {
        headers,
        credentials:'include'
    }).then(function(res){
        if(res.status === 401){

        }
        return res.json()
    }).catch(e=>console.log(e))
}